// Renders a sticker preview as an inline SVG string / data URL.
// We generate text-based stickers (pill / circle) with brand colors.

function escapeXml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

function wrapLines(name) {
  // break into max 3 lines by word count
  const words = name.split(" ");
  if (words.length <= 2) return [name];
  if (words.length <= 4) {
    const mid = Math.ceil(words.length / 2);
    return [words.slice(0, mid).join(" "), words.slice(mid).join(" ")];
  }
  const third = Math.ceil(words.length / 3);
  return [
    words.slice(0, third).join(" "),
    words.slice(third, third * 2).join(" "),
    words.slice(third * 2).join(" "),
  ];
}

// Returns SVG markup (string). width/height controls viewport.
export function stickerSvg({ name, color = "#FF5A36", textColor = "#FFFFFF", design_style = "pill", size = 320 }) {
  const lines = wrapLines(escapeXml(name));
  const w = size;
  const h = size;
  const cx = w / 2;
  const cy = h / 2;
  const shape = design_style === "circle"
    ? `<circle cx="${cx}" cy="${cy}" r="${w * 0.46}" fill="${color}" />
       <circle cx="${cx}" cy="${cy}" r="${w * 0.46}" fill="none" stroke="#fff" stroke-opacity="0.85" stroke-width="6" stroke-dasharray="4 8" />`
    : `<rect x="${w * 0.08}" y="${h * 0.26}" width="${w * 0.84}" height="${h * 0.48}" rx="${h * 0.24}" fill="${color}" />
       <rect x="${w * 0.08}" y="${h * 0.26}" width="${w * 0.84}" height="${h * 0.48}" rx="${h * 0.24}" fill="none" stroke="#fff" stroke-opacity="0.85" stroke-width="6" stroke-dasharray="4 8" />`;

  const fontSize = lines.length === 1 ? w * 0.14 : lines.length === 2 ? w * 0.11 : w * 0.085;
  const lineGap = fontSize * 1.08;
  const startY = cy - ((lines.length - 1) * lineGap) / 2 + fontSize * 0.35;
  const texts = lines
    .map((line, i) =>
      `<text x="${cx}" y="${startY + i * lineGap}" text-anchor="middle" font-family="Outfit, Arial, sans-serif" font-weight="800" font-size="${fontSize}" fill="${textColor}" letter-spacing="-0.5">${line.toUpperCase()}</text>`
    )
    .join("");

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="100%" height="100%">
    <defs>
      <pattern id="dots" x="0" y="0" width="18" height="18" patternUnits="userSpaceOnUse">
        <circle cx="2" cy="2" r="1.4" fill="#D5CEC2" />
      </pattern>
    </defs>
    <rect width="${w}" height="${h}" fill="url(#dots)" opacity="0.9" />
    ${shape}
    ${texts}
  </svg>`;
}

export function stickerDataUrl(opts) {
  const svg = stickerSvg(opts);
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
